export var PLUGIN_NAME = 'hm_video';
export var VIDEO_TAG_REGEX = /@\[video\]\([\s]*(.*?)[\s]*[)]/im;